import { useVisibilityObserver } from '@ktag/styleguide/dist/react';
import React, { useRef } from 'react';

interface Props {
  votes: number;
  type: string;
}

const PollBarFragment = ({ votes, type }: Props) => {
  const myRef = useRef<HTMLDivElement>();
  const isVisible = useVisibilityObserver(myRef);
  const style = { [`--${type}-width`]: `${votes}%` } as React.CSSProperties;

  return (
    <div ref={myRef} className={isVisible ? `pollbar__${type}` : ''} style={style} />
  );
};

export default PollBarFragment;
